<template>
  <div>
    <a-form-model ref="form" :model="form" :rules="rules">
      <a-form-model-item label="审批对象" prop="operation_roles">
        <a-table :pagination="false" :data-source="form.props.operation_roles" :columns="columns" size="middle">
          <template slot="role" slot-scope="text, record">
            <a-select v-model="record.role">
              <a-select-option value="QA">质量</a-select-option>
              <a-select-option value="DEV">研发</a-select-option>
              <a-select-option value="PM">产品</a-select-option>
              <a-select-option value="OM">运营</a-select-option>
              <a-select-option value="DBA">DBA</a-select-option>
              <a-select-option value="OPS">运维</a-select-option>
              <a-select-option value="PMOM">产品运营</a-select-option>
              <a-select-option value="CREATOR">创建人</a-select-option>
            </a-select>
          </template>
          <template slot="required" slot-scope="text, record">
            <a-checkbox v-model="record.required" />
          </template>
          <template slot="sign_method" slot-scope="text, record">
            <a-select v-model="record.sign_method">
              <a-select-option value="AND">会签</a-select-option>
              <a-select-option value="OR">或签</a-select-option>
            </a-select>
          </template>
          <template slot="message" slot-scope="text, record">
            <a-select v-model="record.message">
              <a-select-option :value="1">普通消息</a-select-option>
              <a-select-option :value="2">审批消息</a-select-option>
            </a-select>
          </template>
          <template slot="description" slot-scope="text, record">
            <a-input v-model="record.description" />
          </template>
        </a-table>
        <a-button type="primary" @click="addOperation">添加审批项</a-button>
      </a-form-model-item>
      <a-form-model-item label="审批顺序" prop="move_mode">
        <a-radio-group v-model="form.props.move_mode">
          <a-radio :value="1"> 同时审批 </a-radio>
          <a-radio :value="2"> 顺序审批 </a-radio>
        </a-radio-group>
      </a-form-model-item>
      <a-form-model-item label="节点描述" prop="description">
        <a-textarea v-model="form.description" placeholder="请填写节点描述信息" />
      </a-form-model-item>
      <a-form-model-item label="退回节点" prop="description">
        <a-select v-model="form.props.back_options" mode="multiple">
          <a-select-option v-for="(item, key) in nodeMap" :key="key" :value="item.id">{{ item.name }}</a-select-option>
        </a-select>
      </a-form-model-item>
    </a-form-model>
  </div>
</template>

<script>
const columns = [
  {
    title: '审批角色',
    width: 120,
    dataIndex: 'role',
    scopedSlots: { customRender: 'role' }
  },
  {
    title: '审批方式',
    width: 120,
    align: 'center',
    scopedSlots: { customRender: 'sign_method' }
  },
  {
    title: '消息类型',
    width: 120,
    align: 'center',
    scopedSlots: { customRender: 'message' }
  },
  {
    title: '必填',
    width: 50,
    align: 'center',
    scopedSlots: { customRender: 'required' }
  },
  {
    title: '审批事项',
    width: 120,
    align: 'center',
    scopedSlots: { customRender: 'description' }
  }
];
export default {
  data() {
    return {
      columns,
      rules: {},
      releaseTypes: []
    };
  },
  computed: {
    form() {
      return this.$store.state.selectedNode;
    },
    nodeMap() {
      const nodes = {};
      this.$store.state.nodeMap.forEach((value, key) => {
        if (this.form.id !== key) {
          nodes[key] = value;
        }
      });
      console.log(nodes);
      return nodes;
    }
  },
  methods: {
    addOperation() {
      this.form.props.operation_roles.push({
        role: null,
        sign_method: 'AND',
        message: 1,
        description: null
      });
    }
  }
};
</script>

<style scoped>
.ant-drawer-body {
  padding: 0px;
}
</style>
